import ProductList from '@/components/product/ProductList'

const ProductsPage = () => {
  return <ProductList />
}

export default ProductsPage
